import * as yup from "yup";

import { EMAIL_REGEX } from "../../../../constants.ts";

export const validationSchema = yup.object().shape({
  email: yup
    .string()
    .trim()
    .required("Email is required")
    .matches(EMAIL_REGEX, { message: "Invalid email address" }),
});
